import getGuid from "./getGuid";
import newGuid from "./newGuid";

/* eslint-disable */
export default function createGuid() {
  let sGuid = getGuid();
  if (!sGuid) {
    sGuid = newGuid();
  }
  return sGuid;
}
